import { computed } from 'vue';
import { useStorage } from '@vueuse/core';

interface SearchHistory {
  [identifierKey: string]: string[];
}

interface SearchHistoryOptions {
  removeDuplicates: boolean;
  maxEntries: number;
}

const searchHistoryStorageKey = 'GA_SEARCH_HISTORY';

const defaultOptions: SearchHistoryOptions = {
  removeDuplicates: true,
  maxEntries: 100,
};

export default function useSearchHistory(identifierKey: string, options?: SearchHistoryOptions) {
  const entireHistory = useStorage<SearchHistory>(searchHistoryStorageKey, {});
  const history = computed(() => entireHistory.value[identifierKey] || []);
  const _options = { ...defaultOptions, ...options };
  const add = (entry: string) => {
    if (!entry || typeof entry !== 'string') {
      return;
    }

    if (_options.removeDuplicates) {
      remove(entry);
    }

    entireHistory.value = {
      ...entireHistory.value,
      [identifierKey]: [entry, ...history.value].slice(0, _options.maxEntries),
    };
  };

  const remove = (entry: string) => {
    entireHistory.value = {
      ...entireHistory.value,
      [identifierKey]: [...history.value.filter(val => val !== entry)],
    };
  };

  return {
    history,
    add,
    remove,
  };
}
